import styled from '@emotion/styled/macro'

export const InputFieldInput = styled.input<{
  fieldColor: string
  isLeadingIcon: boolean
  customWidth?: string
}>`
  font-size: 1rem;
  outline: none;
  border: 1px solid gray;
  border-radius: 5px;
  padding: ${({ isLeadingIcon }) =>
    isLeadingIcon ? '1rem 32px' : '1rem 0.7rem'};
  color: gray;
  transition: 0.1s ease-out;
  width: ${({ customWidth }) => customWidth || '200px'};
  &:focus {
    border-color: ${({ fieldColor }) => fieldColor};
  }
`
